module["exports"] = [
  "ASC",
  "MMC",
  "QSC",
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/az/company/prefix.js
// module id = 179
// module chunks = 0